import type React from "react"
import { BlurredContent } from "@/components/BlurredContent"

interface ComplaintsProps {
  schoolData: {
    skolenhetskod: string
    name: string
    missforhallanden_2023?: string[]
    missforhallanden_2024?: string[]
    missforhallanden_2025?: string[]
  }
}

const Complaints: React.FC<ComplaintsProps> = ({ schoolData }) => {
  const complaints2023 = schoolData.missforhallanden_2023 || []
  const complaints2024 = schoolData.missforhallanden_2024 || []
  const complaints2025 = schoolData.missforhallanden_2025 || []

  const renderComplaints = (year: string, complaints: string[]) => {
    return (
      <BlurredContent>
        {complaints.length === 0 ? (
          <p>Inga anmälningar hittades</p>
        ) : (
          <ul className="list-disc pl-5">
            {complaints.map((complaint, index) => (
              <li key={index}>{complaint}</li>
            ))}
          </ul>
        )}
      </BlurredContent>
    )
  }

  return (
    <div>
      <div className="mb-6 text-sm text-gray-700">
        <p className="mb-2">
          Nedan redovisas anmälningar till Barn- och elevombudet mellan tidsperioden 1 januari 2023 och 2 april
          2025, som har lett till en riktad tillsyn från Skolinspektionen. Oftast handlar dessa ärenden om:
        </p>
        <ul className="list-disc pl-5 mb-2">
          <li>kränkningar mellan elever, eller</li>
          <li>kränkningar mellan elev och lärare, eller</li>
          <li>elever som inte har fått det särskilda stöd som de har rätt till</li>
        </ul>
        <p className="mb-2">
          Notera att datan gäller anmälningar, oavsett vilket beslut som togs. Ungefär 1/3 av anmälningarna leder till
          ett beslut om konstaterad brist. Det går att läsa mer om detta på{" "}
          <a
            href="https://www.skolinspektionen.se/statistik/statistik-om-tillsyn/riktad-tillsyn/riktad-tillsyn--individ-forsta-halvaret-2024/"
            target="_blank"
            rel="noopener noreferrer"
            className="text-blue-600 hover:underline"
          >
            Skolinspektionens hemsida
          </a>
          .
        </p>
      </div>
      <div className="mb-4">
        <h3 className="text-lg font-semibold mb-2">2023</h3>
        {renderComplaints("2023", complaints2023)}
      </div>
      <div className="mb-4">
        <h3 className="text-lg font-semibold mb-2">2024</h3>
        {renderComplaints("2024", complaints2024)}
      </div>
      <div className="mb-4">
        <h3 className="text-lg font-semibold mb-2">2025</h3>
        {renderComplaints("2025", complaints2025)}
      </div>
      <p className="mt-4 text-sm text-gray-600">Källa: Skolinspektionen</p>
    </div>
  )
}

export default Complaints

